"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.authorPreviewFlowRunPath = authorPreviewFlowRunPath;
exports.authorPreviewBase = authorPreviewBase;
exports.parseAuthorPreviewAddress = parseAuthorPreviewAddress;
const app_base_preview_selection_1 = require("./app-base-preview-selection");
function authorPreviewFlowRunPath(token) {
    return `/${app_base_preview_selection_1.AUTHOR_PREVIEW_FLOW_RUN_SEGMENT}/${encodeURIComponent(token)}`;
}
/** Address of the author-only preview of one saved version of an App Container. */
function authorPreviewBase(workspaceId, appBaseId, version, slug) {
    return `/api/workspaces/${encodeURIComponent(workspaceId)}/app-bases/${encodeURIComponent(appBaseId)}/preview/${version}/${encodeURIComponent(slug)}`;
}
const PREVIEW_URL = new RegExp(`^/api/workspaces/([^/]+)/app-bases/([^/]+)/preview/([1-9][0-9]*)/([^/]+)(?:/${app_base_preview_selection_1.AUTHOR_PREVIEW_ACCESS_SEGMENT}/([^/]+))?(?:/${app_base_preview_selection_1.AUTHOR_PREVIEW_FLOW_RUN_SEGMENT}/([^/]+))?(/.*)?$`);
function parseAuthorPreviewAddress(value) {
    // Parse the raw path so URL dot-segment normalization cannot change scope.
    const [pathname, ...query] = value.split('?');
    const match = pathname.match(PREVIEW_URL);
    if (!match)
        return null;
    const version = Number(match[3]);
    if (!Number.isSafeInteger(version))
        return null;
    try {
        const [workspaceId, appBaseId, appBaseSlug] = [
            match[1],
            match[2],
            match[4],
        ].map(decodeURIComponent);
        if (![workspaceId, appBaseId, appBaseSlug].every(part => part.length > 0 &&
            !/[\\/#?\u0000-\u0020]/.test(part) &&
            part !== '.' &&
            part !== '..'))
            return null;
        const suffix = match[7] ?? '';
        const decodedSuffix = decodeURIComponent(suffix);
        if (/[\\\u0000-\u0020]/.test(decodedSuffix) ||
            decodedSuffix.split('/').some(part => part === '.' || part === '..'))
            return null;
        return {
            workspaceId,
            appBaseId,
            appBaseSlug,
            version,
            basePath: authorPreviewBase(workspaceId, appBaseId, version, appBaseSlug),
            ...(match[5] ? { accessToken: match[5] } : {}),
            ...(match[6] ? { flowRunToken: match[6] } : {}),
            suffix,
            search: query.length ? `?${query.join('?')}` : '',
        };
    }
    catch {
        return null;
    }
}
